import React, { useState, useEffect } from "react";
import {
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField, InputAdornment, MenuItem, Typography,
} from "@mui/material";
import CardGiftcardRoundedIcon from "@mui/icons-material/CardGiftcardRounded";
import { useSnackbar } from "notistack";
import LoadingButton from "../../components/elements/LoadingButton";
import { currencySymbol } from "../../../config/values";
import { defaultVariables } from "../../../config";
import axios from "axios";
import { getStore } from "trim-redux";
import NumberField from "../../components/elements/fields/NumberField";
import Grid from "@mui/material/Grid2";
import RayaField from "../../components/elements/fields/RayaField";
import {useTranslation} from "react-i18next";

// Imports stay the same...

const AddTransactionDialog = ({ user_id, variant, style, purchase, reload, width }) => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [error, setError] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);

    const [fields, setFields] = useState({
        amount: "",
        type: "deposit",
        description: "",
        track_code: "",
    });


    const toggleDialog = () => setOpen((prev) => !prev);

    const handleInputChange = (field, value) => {
        setFields((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (fields.amount <= 0 || !fields.type || !fields.description) {
            enqueueSnackbar(t("addAmountAndDescription"), { variant: "warning" });
            return;
        }

        setSubmitLoading(true);

        try {
            const authUser = getStore().user;
            if (!authUser.role.permission.managePayments) {
                enqueueSnackbar(t("youDontHavePermission"), { variant: "error" });
                setSubmitLoading(false);
                return;
            }

            const loginToken = localStorage.getItem("ACT");
            const config = {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${loginToken}`,
                },
            };

            const payload = {
                user_id: user_id,
                ...fields,
            };

            await axios.post(`${defaultVariables.url}/wallets/add-transaction`, payload, config);
            reload();
            setOpen(false);
        } catch (error) {
            console.error(error.response);
            enqueueSnackbar(t("detailsSetFailed"), { variant: "error" });
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <>
            <Button
                variant={variant || "contained"}
                color="primary"
                style={style}
                onClick={toggleDialog}
            >
                {t("addTransaction")}
            </Button>

            <Dialog fullWidth maxWidth="sm" open={open} onClose={toggleDialog}>
                <DialogTitle>{t("addTransaction")}</DialogTitle>
                <DialogContent>

                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <Typography>{t("addTransactionDesc")}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <NumberField
                                fullWidth
                                label={t('amount')}
                                variant="outlined"
                                value={fields.amount}
                                endAdornment={currencySymbol}
                                decimals={2}
                                min={0}
                                onChange={(val) => handleInputChange('amount', val)}
                            />
                        </Grid>
                        <Grid item size={12}>
                            <RayaField
                                fullWidth
                                select
                                label={t('type')}
                                variant="outlined"
                                value={fields.type}
                                onChange={(e) => handleInputChange('type', e.target.value)}
                            >
                                <MenuItem value="deposit">{t("deposit")}</MenuItem>
                                <MenuItem value="withdraw">{t("withdraw")}</MenuItem>
                            </RayaField>
                        </Grid>
                        <Grid item size={12}>
                            <RayaField
                                fullWidth
                                label={t('description')}
                                variant="outlined"
                                value={fields.description}
                                onChange={(e) => handleInputChange('description', e.target.value)}
                            />
                        </Grid>
                        <Grid item size={12}>
                            <RayaField
                                fullWidth
                                label={t('transactionTrackingCode')}
                                variant="outlined"
                                value={fields.track_code}
                                onChange={(e) => handleInputChange('track_code', e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        loading={submitLoading}
                    >
                        {t("addTransaction")}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AddTransactionDialog;

